import loadable from '@loadable/component';

export const ThemoneyeditSiteWrapper = loadable(
  () => import(/* webpackChunkName: "themoneyedit-site" */ './ThemoneyeditSiteWrapper'),
);
